import { render, staticRenderFns } from "./InputInboxDraft.vue?vue&type=template&id=19400b18&scoped=true&"
import script from "./InputInboxDraft.vue?vue&type=script&lang=js&"
export * from "./InputInboxDraft.vue?vue&type=script&lang=js&"
import style0 from "./InputInboxDraft.vue?vue&type=style&index=0&id=19400b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19400b18",
  null
  
)

export default component.exports